import { render, staticRenderFns } from "./PageNotAuthorized.vue?vue&type=template&id=09cac20c&scoped=true&"
import script from "./PageNotAuthorized.vue?vue&type=script&lang=js&"
export * from "./PageNotAuthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cac20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09cac20c')) {
      api.createRecord('09cac20c', component.options)
    } else {
      api.reload('09cac20c', component.options)
    }
    module.hot.accept("./PageNotAuthorized.vue?vue&type=template&id=09cac20c&scoped=true&", function () {
      api.rerender('09cac20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/notauthorized/PageNotAuthorized.vue"
export default component.exports